<template><div><h1 id="retourenauswertung-nach-retourcode" tabindex="-1"><a class="header-anchor" href="#retourenauswertung-nach-retourcode"><span>Retourenauswertung nach Retourcode</span></a></h1>
<p>Retourenauswertung nach Retourcode — Retourenauswertung nach Retourcode</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung wertet alle Aufträge mit entsprechender Auftragsart, die in angegebenem Zeitraum erfasst wurden. Ergebnis ist eine Liste der Artikel, die in Aufrägen vorkommen, Einkaufspreis, gelieferte Menge, Retourmenge und die Retourmenge noch im Detail nach Retourcode.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Retourenauswertung nach Retourcode</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Erfassungsdatum von</dt>
<dd>Erfassungsdatum des Auftrags</dd>
<dt>bis</dt>
<dd>Erfassungsdatum des Auftrags</dd>
<dt>Auftragsart(en)</dt>
<dd>Auftragsarten, mit Komma trennen, mit ! ausschliessen, * = alle</dd>
<dt>Ausgabedatei</dt>
<dd>Export in eine Datei in Excel- oder HTML-Format. Definition durch Suffix *.xls oder *.html</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>EkPreis</td>
<td>Einkaufspreis des Artikels</td>
</tr>
<tr>
<td>geliefert</td>
<td>gelieferte Menge vom Artikel</td>
</tr>
<tr>
<td>retour</td>
<td>retournierte Menge vom Artikel</td>
</tr>
<tr>
<td>Code</td>
<td>Retournierte Menge vom Artikel nach Retourcode aufgeschlüsselt (0-9, oder Rest = nicht zugeordnet).</td>
</tr>
</tbody>
</table>
</div></template>


